module.exports = __webpack_public_path__ + "img/seo.26525232.gif";